/**
 * App Dark Theme
 */
import { createTheme } from '@mui/material/styles';
import {grey}from '@mui/material/colors';

import AppConfig from '../../constants/AppConfig';

const { darkBgColor } = AppConfig.darkThemeColors;

const theme = createTheme({
    palette: {
        type: 'dark',
        types: {
            dark: {
                background: {
                    paper: darkBgColor,
                    default: darkBgColor,
                    appBar: darkBgColor,
                    contentFrame: darkBgColor,
                    chip: darkBgColor,
                    avatar: darkBgColor,
                    tabs: darkBgColor
                }
            }
        },
        primary: {
            main: AppConfig.themeColors.primary,
            contrastText: '#fff'
        },
        secondary: {
            main: grey[700],
            contrastText: '#fff'
        },
        background: {
            paper: darkBgColor,
            default: darkBgColor,
            appBar: darkBgColor,
            contentFrame: darkBgColor,
            chip: darkBgColor,
            avatar: darkBgColor,
            tabs: darkBgColor
        }
    },
    status: {
        danger: 'orange',
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        }
    }
});

export default theme;
